module.exports = __webpack_public_path__ + "013bff7d83bee657f1be00a35dcb7622.svg";